const googleCalendar = {
  upcoming: "Upcoming Events",
  today: "Today",
  tomorrow: "Tomorrow",
  allDay: "All day",
  noEvents: "No upcoming events",
  noAccount: "No Google Calendar account connected",
  connectAccount: "Connect account in Settings",
  openInCalendar: "Open in Google Calendar",
  startsIn: "Starts in",
} as const;
export default googleCalendar;
